// Bootstrap 3 nao empilha modais aninhados corretamente (o backdrop do 2o modal fica
// abaixo do 1o e o foco/aria-hidden conflitam). Este handler ajusta o z-index de cada
// modal aberto e do respectivo backdrop conforme a quantidade de modais visiveis.
// Usado quando o dialog de reprogramacao abre sobre o dialog da viagem.
(function () {
  if (typeof jQuery === 'undefined') { return; }
  jQuery(document).on('show.bs.modal', '.modal', function () {
    var zIndex = 1040 + (10 * jQuery('.modal:visible').length);
    jQuery(this).css('z-index', zIndex);
    setTimeout(function () {
      jQuery('.modal-backdrop').not('.modal-stack')
        .css('z-index', zIndex - 1)
        .addClass('modal-stack');
    }, 0);
  });
  // Mantem o scroll do body enquanto ainda houver algum modal aberto.
  jQuery(document).on('hidden.bs.modal', '.modal', function () {
    if (jQuery('.modal:visible').length > 0) {
      jQuery('body').addClass('modal-open');
    }
  });
})();
